'use client';

import { FC } from 'react';
import { usePathname } from 'next/navigation';
import classNames from 'classnames';
import { ContentContainer } from './content-container';
export type TabDatum = {
  href: string;
  title: string;
  exact?: boolean;
};
export const TabItem: FC<TabDatum> = ({
  title,
  href,
  exact
}) => {
  const pathname = usePathname();
  const active = exact ? pathname === href : pathname?.startsWith(href);
  return <a className={classNames('inline-flex items-center text-center text-sm md:text-base lg:text-lg px-2 md:px-4 md:px-12 py-2 border -mb-[1px] rounded-t font-bold transition-colors whitespace-nowrap', {
    'border-b-white border-gray-300 text-primary bg-white': active,
    'border-transparent text-primary dark:text-white hover:text-clippd-pink bg-white/0 hover:bg-white/20 active:bg-black active:bg-white/30 active:transition-none focus:bg-black focus:bg-white/30': !active
  })} href={href} data-sentry-component="TabItem" data-sentry-source-file="nav-tabs.tsx">
      {title.includes('Live') ? <svg width="15" height="16" viewBox="0 0 15 16" fill="none" className="mr-2">
          <rect y="0.249207" width="15" height="15" rx="7.5" fill="#FCA5A5" />
          <circle cx="7.5" cy="7.74921" r="5" fill="#DC2626" />
        </svg> : null}
      {title}
    </a>;
};
type TabsProps = {
  items: TabDatum[];
};
export const NavTabs: FC<TabsProps> = ({
  items
}) => {
  return <div className="flex dark:bg-primary border-b border-gray-300 dark:border-b-0 pt-4 space-x-1 h-tab-nav-mobile lg:h-tab-nav" data-sentry-component="NavTabs" data-sentry-source-file="nav-tabs.tsx">
      {items.map(item => <TabItem key={item.href} {...item} />)}
    </div>;
};
export const ContentContainerNavTabs: FC<TabsProps> = ({
  items
}) => {
  return <div className="dark:bg-primary border-b border-gray-300 dark:border-b-0 pt-4" data-sentry-component="ContentContainerNavTabs" data-sentry-source-file="nav-tabs.tsx">
      <ContentContainer suppressVerticalMargin data-sentry-element="ContentContainer" data-sentry-source-file="nav-tabs.tsx">
        <div className="flex space-x-1">
          {items.map(item => <TabItem key={item.href} {...item} />)}
        </div>
      </ContentContainer>
    </div>;
};